// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const transferStatusValueSchema = z.enum(['DRAFT', 'SUBMITTED', 'CONFIRMED', 'REJECTED', 'PENDING', 'FAILED', 'CANCELED'])

export const transferStatusSchema = z.object({
  value: transferStatusValueSchema,
  message: z.string().optional(),
  updatedAt: z.string().datetime().optional(),
})
